import { render, staticRenderFns } from "./MotionAlarmReportScreen.vue?vue&type=template&id=6b40a6cb"
import script from "./MotionAlarmReportScreen.vue?vue&type=script&lang=js"
export * from "./MotionAlarmReportScreen.vue?vue&type=script&lang=js"
import style0 from "./MotionAlarmReportScreen.vue?vue&type=style&index=0&id=6b40a6cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports